import { render, staticRenderFns } from "./PORTFOLIOACTION.vue?vue&type=template&id=7403600b"
import script from "./PORTFOLIOACTION.vue?vue&type=script&lang=js"
export * from "./PORTFOLIOACTION.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports